import { createSelector } from '@reduxjs/toolkit';
import { chatWindowSelector } from '../chatWindowSelector/chatWindowSelector';

export const selectActiveReplyMessage = createSelector(
  chatWindowSelector,
  chatWindow => chatWindow?.activeReplyMessage,
);
